import type React from 'react'

/**
 * Put on a floating chrome root's `onPointerDown`/`onPointerUp`/`onClick`: the root is portalled
 * to `document.body`, but React still bubbles its synthetic events up the component tree into the
 * canvas, whose own handlers would otherwise treat a click on the toolbar as a canvas gesture.
 */
export function stopPropagation(e: React.SyntheticEvent) {
  e.stopPropagation()
}
